import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import perm from './modules/perm'
import region from './modules/region'
import brand from './modules/brand'
import brandField from './modules/brand_field'
import currency from './modules/currency'
import language from './modules/language'
import timezone from './modules/timezone'
import tagsView from './modules/tagsView'
import industry from './modules/industry'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    perm,
    region,
    brand,
    brandField,
    currency,
    language,
    timezone,
    tagsView,
    industry
  },
  getters
})

export default store
